export default {
      id: "common__status_favorite-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__status_favorite",
      toString: function () {
        return this.url;
      }
    }